import {
  addDoc,
  arrayUnion,
  collection,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateSchool = async (e, uid) => {
  try {
    const SchoolsCollection = await collection(db, "Schools");

    const data = HelperForMetaData({
      ...e,
      uid: uid,
      adminId: uid,
    });
    await addDoc(SchoolsCollection, data).then((ref) => {
      let UserRef = doc(db, `Users`, uid);
      try {
        updateDoc(
          UserRef,
          {
            SchoolID: arrayUnion(ref.id),
          },
          { merge: true }
        );
      } catch (error) {
        console.log(error);
      }
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateSchool;
